


product_id = undefined; // DO NOT add let, const, or var -- logs err in console 


function openModal4CollectionProductCard(productId) {
    /**
    @description: Selects div tags with class attr val `collection_product_overlay` and `collection_product_modal_container`. Applies
    Css to both el to create UI modal and sets modal container to have same HTML structure and vals 
    as the product card
    @param {HTML} productId: HTML product card structure, el, and vals 
    **/
    product_id = productId; 
    let modalOverlay    = htmlEl('.collection_product_overlay'), 
        modalContainer  = htmlEl('.collection_product_modal_container'), 
        closeModalBtn   = createHtmlEl('div')
        ; 
        
    modalOverlay.style.display      = 'block'; 
    document.body.style.overflow    = 'hidden'; 
    modalContainer.style.display    = 'block'; 
    modalContainer.style.width      = 'max-content';

    modalContainer.innerHTML = htmlEl(`#modal_product_card_id_${productId}`).innerHTML; // copies product card to collection_product_modal_container 
    let modalDescHtmlEl = modalContainer.querySelector('.collection_product_card_desc'); 

    closeModalBtn.classList  = 'closeModalBtn'; 
    closeModalBtn.innerHTML  = '&times;'; 

    if (modalDescHtmlEl.clientHeight > 185) {
        modalDescHtmlEl.style.height = '250px'; 
        modalDescHtmlEl.style.overflowY = 'auto'; 
    }
    // applyProductCardCover(productId); 
    modalContainer.appendChild(closeModalBtn); 
    closeModalBtn.addEventListener('click', closeModal4CollectionProductCard); 
    showFullProductDetails4Over200(modalContainer); 
    applyMobileStyleTo(modalDescHtmlEl); 

}



function showFullProductDetails4Over200(modalContainer) {
    /**
    @description: Expands css line clamp, removes product card's 'See Full Desc', 
    `.collection_product_overlay`, and `collection_product_modal_container`. Effectivly cleans up modal container artifacts. 
    @param {HTML} modalContainer: An html div el that contains info from product card 
    **/
    modalContainer.querySelector('.collection_product_card_desc').style.webkitLineClamp = '999';
    modalContainer.querySelector('.collection_product_overlay').remove() 
    modalContainer.querySelector('.collection_product_modal_container').remove() 
}



function applyProductCardCover(productId) {
    /**
    @description: Renders 'Add to cart' and 'buy now' btns
    **/ 
    document.getElementById(`product_card_id_${productId}`).querySelector('.over_200_product_card_cover').style.display = 'block'; 
}



function closeModal4CollectionProductCard() {
    /**
    @description: closes the modal by changing css property display to none
    **/
    let modalOverlay    = htmlEl('.collection_product_overlay'), 
        modalContainer  = htmlEl('.collection_product_modal_container')
    ; 
    modalOverlay.style.display = 'none';
    modalContainer.style.display = 'none';
    document.body.style.overflow = ''; // Restore scrolling
    modalContainer.innerHTML = ''; // Clear the modal content
}


function applyMobileStyleTo(modalDescHtmlEl) {
    /**
    @description: Applies special CSS val for mobile view 
    @param {HTML} modalDescHtmlEl: HTML el pertaining to the modal desc field 
    **/
    if (window.screen.width <= 415 && window.screen.height <= 915) {  
        modalDescHtmlEl.style.height = '325px'; 
        modalDescHtmlEl.style.overflowY = 'auto'; 
    }
}



function applyOrRemoveStyles() {
    /**
    @description: fn to apply or remove the styles based on the window size
    **/
    if (window.innerWidth >= 720) {
        document.querySelectorAll('.search_res_modal_btns_container').forEach(btns_container => {
            // Add your styles for window.innerWidth >= 720px here, or you can remove any specific style properties.
            btns_container.style.position = 'absolute';
            btns_container.style.top = '560px';
            btns_container.style.right = '10.3px';   
        });
    } 
}
i = 0;
function flashElement(element) {
    speed = 100;
    
        setTimeout(function () {
            element.style.transform = 'scale(1.34)';
            element.style.transform = 'saturation(1.8)'
            setTimeout(function () {
                element.style.transform = 'scale(1)';
                element.style.transform = 'saturation(1)'
                if (i < 2){ flashElement(element); }
                i++;
            }, speed);
        }, speed);

}

function clearCheckedArray() {
    checkedArray = [];
    // Clear any checkboxes if needed
    let checkedCheckboxes = document.querySelectorAll('input[type=checkbox]:checked');
    document.getElementById('compare-clear-buttons').remove();
    for (let checkbox of checkedCheckboxes) {
        checkbox.checked = false;
    }
}

let checkedArray = [];
compare = false;

function boxChecked(event) {

    // Reset the checkedArray when the function is called.
    checkedArray = [];

    // Retrieve all checked checkboxes.
    let checked = document.querySelectorAll('input[type=checkbox]:checked');
    
    if (checked.length > 3) {
        checked[0].checked = false;
        document.getElementById('compare-' + checked[0].id).style.opacity = 0.5;
        checked = document.querySelectorAll('input[type=checkbox]:checked');
    }
    let unchecked = document.querySelectorAll('input[type=checkbox]:not(:checked)');
    for (let i = 0; i < unchecked.length; i++) {
        document.getElementById('compare-' + checked[0].id).style.opacity = 0.5;
    }

    if (checked.length > 3) {

        checked[0].checked = false;
        document.getElementById('compare-' + checked[0].id).style.opacity = 0.5;


    }

    // Populate the checkedArray with the IDs of checked checkboxes.
    for (let i = 0; i < checked.length; i++) {
        checkedArray.push(checked[i].id);
        document.getElementById('compare-' + checked[i].id).style.opacity = 1;
        //document.getElementById('compare-' + checked[i].id).style.transform = 'scale(1)';

        document.getElementById('compare-' + checked[i].id).setAttribute('onclick', 'openModalForComparison()');

    }

    // Remove duplicates from the checkedArray.
    checkedArray = [...new Set(checkedArray)];



    
    }


    function openModalForComparison() {

        let modalOverlay = document.querySelector('.collection_product_overlay');
        let modalContainer = document.querySelector('.collection_product_modal_container');
        let closeModalBtn = document.createElement('div');

        let existingTable = modalContainer.querySelector('.compare-table');
        if (existingTable) {
            modalContainer.removeChild(existingTable);
        }

        modalOverlay.style.display = 'block';
        document.body.style.overflow = 'hidden';
        modalContainer.style.display = 'block';
        modalContainer.style.maxWidth = '90%';
        modalContainer.style.width = 'min-content';
        modalContainer.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
        modalContainer.style.overflowX = 'auto';



        // Create a table for comparison
        let table = document.createElement('table');
        table.classList = 'compare-table';
        table.style.border = 'none'; // Remove table borders

        // Create table header
        let tableHead = document.createElement('thead');
        let tableHeadRow = document.createElement('tr');

        let tableHeadCell = document.createElement('th');
        tableHeadCell.innerHTML = ''; // Set the title as the header
        tableHeadRow.appendChild(tableHeadCell);

        for (let i = 0; i < checkedArray.length; i++) {
            let productNumber = checkedArray[i].replace('product', '');
            let productData = document.getElementById('collection_product_card_container' + productNumber).dataset;
            let url = productData.url;
            let productTitle = document.querySelector('#collection_product_card_container' + productNumber + ' .collection_product_card_title');
            if (productTitle.textContent.length > 90) {
                productTitle.textContent = productTitle.textContent.slice(0, 90) + '...';
            }
            let tableHeadCell = document.createElement('th');
            tableHeadCell.innerHTML = productTitle.textContent; // Set the title as the header
            tableHeadRow.appendChild(tableHeadCell);
            tableHeadCell.style.cursor = 'pointer';
            tableHeadRow.addEventListener('click', function() {
                window.location.href = url;
            });
        }
        tableHead.appendChild(tableHeadRow);
        table.appendChild(tableHead);

        // Create table body and rows with labels and images
        let tableBody = document.createElement('tbody');
        let attributeLabels = {  
            'processors': 'Processor',
            'no_cores': 'Cores',
            'processors_clockspeed': 'CPU Speed',
            'total_mem_cap': 'Total RAM',
            'memory_speed': 'Memory Speed',
            'mem_type': 'Memory Type',
            'mem_cap_per_mod': 'Capacity per Module',
            'mem_no_inst': 'Modules installed',
            'raid_controller':'RAID Controller',
            'storage': 'Storage Capacity',
            'nic': 'NIC',
            'rails': 'Rails',
            'software': 'Software',
            'remote_ac': 'Remote Access',
            'price': 'Price',

            

        };


        // Create the first row for images
        let imageRow = document.createElement('tr');

        let cell = document.createElement('td');
        imageRow.appendChild(cell);

        for (let id of checkedArray) {
            let productNumber = id.replace('product', '');
            let productImage = document.querySelector('#collection_product_card_container' + productNumber + ' .collection_product_card_img');
            let cell = document.createElement('td');
            let image = document.createElement('img');
            image.src = productImage.src;
            image.style.borderRadius = '8px';
            cell.appendChild(image);
            imageRow.appendChild(cell);
        }
        if (window.innerWidth > 768){
        imageRow.style.cursor = 'pointer';
        imageRow.addEventListener('click', function() {
                window.location.href = url;
            });
        tableBody.appendChild(imageRow);

        }

        // Create rows for attribute labels and values
        for (let attr of Object.keys(attributeLabels)) {
            let row = document.createElement('tr');
            let labelCell = document.createElement('td');
            labelCell.innerHTML = attributeLabels[attr];
            row.appendChild(labelCell);
            for (let id of checkedArray) {
                let productNumber = id.replace('product', '');
                let productData = document.getElementById('collection_product_card_container' + productNumber).dataset;
                let cell = document.createElement('td');

                if (productData[attr] === undefined) {
                    productData[attr] = 'N/A';
                } else {
                    if (attributeLabels[attr] === 'Storage Capacity') {
                    if (productData[attr].length > 3){
                    productData[attr] = productData[attr] / 1000;
                    productData[attr] = productData[attr] + ' TB';
                    } else if (productData[attr] != ''){
                        productData[attr] = productData[attr] + ' GB';
                    }
                }
                cell.innerHTML = productData[attr];
                }
                row.appendChild(cell);
            }
            tableBody.appendChild(row);
        }
        table.appendChild(tableBody);

        let buttonRow = document.createElement('tr');

        let buttonCell = document.createElement('td');
        buttonCell.innerHTML = ''; 
        buttonRow.appendChild(buttonCell);

        for (let id of checkedArray) {
            let productNumber = id.replace('product', '');
            let buttonsContainer = document.querySelector('#collection_product_card_container' + productNumber + ' .search_res_modal_btns_container');
            
            let cell = document.createElement('td');
            cell.innerHTML = buttonsContainer.innerHTML;
            buttonRow.appendChild(cell);
        }

        tableBody.appendChild(buttonRow);

        modalContainer.appendChild(table);

        closeModalBtn.classList = 'closeModalBtn';
        closeModalBtn.innerHTML = '&times;';
        modalContainer.appendChild(closeModalBtn);

        closeModalBtn.addEventListener('click', closeModal4CollectionProductCard);


        let rows = table.querySelectorAll('tbody tr');
        for (let i = 0; i < rows.length; i++) {
            if (i % 2 === 1) {
                rows[i].style.backgroundColor = '#ababab62';
                rows[i].style.border = 'none';
            }
        }
        table.style.border = 'none'; 
        tableHead.style.border = 'none';
        tableBody.style.border = 'none';

}
// Initial call to apply styles when the page loads
// applyOrRemoveStyles();

// Add event listener for the window resize event
window.addEventListener('resize', applyOrRemoveStyles);

document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') closeModal4CollectionProductCard();
})